// Pure text formatting for the HUD.
import { TRACK_LENGTH } from '../data/track';

/** Gap behind the leader in metres. */
export function formatGap(gap: number): string {
  const m = gap * TRACK_LENGTH;
  if (m < 0.5) return '—';
  return `−${m < 10 ? m.toFixed(1) : Math.round(m)} m`;
}

/** Signed catnip landing change in metres, e.g. "+228 m". */
export function formatDelta(delta: number): string {
  const m = Math.round(delta * TRACK_LENGTH);
  if (m === 0) return '±0 m';
  return `${m >= 0 ? '+' : '−'}${Math.abs(m)} m`;
}

/** m:ss.d */
export function formatTime(seconds: number): string {
  const tenths = Math.round(seconds * 10);
  const m = Math.floor(tenths / 600);
  const s = Math.floor((tenths % 600) / 10);
  return `${m}:${String(s).padStart(2, '0')}.${tenths % 10}`;
}

export function placeWord(place: number, last = 6): string {
  if (place === 1) return 'Win!';
  if (place === last) return '…Last!';
  return ['', '', 'Second', 'Third', 'Fourth', 'Fifth'][place] ?? `${place}th`;
}

export function ordinal(n: number): string {
  return n === 1 ? '1st' : n === 2 ? '2nd' : n === 3 ? '3rd' : `${n}th`;
}

/** Euros in the viewer's locale; signed adds + or − (zero stays unsigned). */
export function formatEuro(v: number, signed = false): string {
  const s = Math.abs(v).toLocaleString(undefined, { style: 'currency', currency: 'EUR' });
  if (!signed || v === 0) return s;
  return `${v > 0 ? '+' : '−'}${s}`;
}
